import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { useAuth } from './context/AuthContext';
import Login from './pages/Auth/Login';
import Register from './pages/Auth/Register';
import ClientList from './pages/Clients/ClientList';
import CreateClient from './pages/Clients/CreateClient';
import EditClient from './pages/Clients/EditClient';
import Dashboard from './pages/Dashboard';
import Layout from './components/Layout';
import PrivateRoute from './components/PrivateRoute';
import ShiftNote from './pages/Shifts/ShiftNote';
import ClientNotes from './pages/Clients/ClientNotes';
import Calendar from './pages/Calendar';
import AddShift from './pages/Shifts/AddShift';
import EditShift from './pages/Shifts/EditShift';
import ShiftList from './pages/Shifts/ShiftList';
import NotesByClient from './pages/Shifts/NotesByClient';
import ForgotPassword from './pages/Auth/ForgotPassword';
import ResetPassword from './pages/Auth/ResetPassword';
const AppRoutes = () => {
  const { user } = useAuth();

  return (
    <Router>
      <Routes>
        {/* Public pages: redirect if logged in */}
        <Route path="/login" element={user ? <Navigate to="/dashboard" /> : <Login />} />
        <Route path="/register" element={user ? <Navigate to="/dashboard" /> : <Register />} />
        <Route path="/forgot-password" element={<ForgotPassword/>} />
        <Route path="/reset-password/:token" element={<ResetPassword/>} />
        {/* Protected routes with layout */}
        <Route path="/*" element={
          <PrivateRoute>
            <Layout>
              <Routes>
                <Route path="/clients" element={<ClientList />} />
                <Route path="/clients/create" element={<CreateClient />} />
                <Route path="/clients/edit/:id" element={<EditClient />} />
                <Route path="/dashboard" element={<Dashboard />} />
                <Route path="/shifts/:id/note" element={<ShiftNote />} />
                <Route path="/clients/:id/notes" element={<ClientNotes />} />
                <Route path="/calendar" element={<Calendar />} />
                <Route path="/shifts" element={<ShiftList />} />
                <Route path="/shifts/:id" element={<ShiftList />} />
                <Route path="/shifts/new" element={<AddShift />} />
                <Route path="/shifts/:id/edit" element={<EditShift />} />
                <Route path="/notes/:id" element={<NotesByClient/>} />
                <Route path="/" element={<Navigate to="/dashboard" />} />
              </Routes>
            </Layout>
          </PrivateRoute>
        } />
      </Routes>
    </Router>
  );
};

export default AppRoutes;
